/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DynamicIbanInvoiceAddCommand } from '../models';
// @ts-ignore
import type { DynamicIbanInvoiceAddResponseDto } from '../models';
/**
 * DynamicIbanInvoiceApi - axios parameter creator
 * @export
 */
export const DynamicIbanInvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DynamicIbanInvoiceAddCommand} [dynamicIbanInvoiceAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDynamicInvoiceNewQrInvoicePost: async (dynamicIbanInvoiceAddCommand?: DynamicIbanInvoiceAddCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dynamic-invoice/new-qr-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dynamicIbanInvoiceAddCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DynamicIbanInvoiceApi - functional programming interface
 * @export
 */
export const DynamicIbanInvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DynamicIbanInvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DynamicIbanInvoiceAddCommand} [dynamicIbanInvoiceAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDynamicInvoiceNewQrInvoicePost(dynamicIbanInvoiceAddCommand?: DynamicIbanInvoiceAddCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DynamicIbanInvoiceAddResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDynamicInvoiceNewQrInvoicePost(dynamicIbanInvoiceAddCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DynamicIbanInvoiceApi.apiDynamicInvoiceNewQrInvoicePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DynamicIbanInvoiceApi - factory interface
 * @export
 */
export const DynamicIbanInvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DynamicIbanInvoiceApiFp(configuration)
    return {
        /**
         * 
         * @param {DynamicIbanInvoiceAddCommand} [dynamicIbanInvoiceAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDynamicInvoiceNewQrInvoicePost(dynamicIbanInvoiceAddCommand?: DynamicIbanInvoiceAddCommand, options?: RawAxiosRequestConfig): AxiosPromise<DynamicIbanInvoiceAddResponseDto> {
            return localVarFp.apiDynamicInvoiceNewQrInvoicePost(dynamicIbanInvoiceAddCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DynamicIbanInvoiceApi - object-oriented interface
 * @export
 * @class DynamicIbanInvoiceApi
 * @extends {BaseAPI}
 */
export class DynamicIbanInvoiceApi extends BaseAPI {
    /**
     * 
     * @param {DynamicIbanInvoiceAddCommand} [dynamicIbanInvoiceAddCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DynamicIbanInvoiceApi
     */
    public apiDynamicInvoiceNewQrInvoicePost(dynamicIbanInvoiceAddCommand?: DynamicIbanInvoiceAddCommand, options?: RawAxiosRequestConfig) {
        return DynamicIbanInvoiceApiFp(this.configuration).apiDynamicInvoiceNewQrInvoicePost(dynamicIbanInvoiceAddCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

